"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var separator_1 = require("@react-aria/separator");

var components_utils_1 = require("@conte-ltd/components-utils");

function _Separator(props, fwRef) {
  var _a = props.orientation,
      orientation = _a === void 0 ? 'horizontal' : _a,
      size = props.size,
      weight = props.weight;
  var separatorProps = (0, separator_1.useSeparator)(__assign(__assign({}, props), {
    elementType: 'div'
  })).separatorProps;
  return (0, jsx_runtime_1.jsx)("div", __assign({
    css: [(0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          background-color: currentColor;\n\n          &[data-orientation='horizontal'] {\n            width: var(--c-separator-size, 100%);\n            height: var(--c-separator-weight, 1px);\n          }\n\n          &[data-orientation='vertical'] {\n            width: var(--c-separator-weight, 1px);\n            height: var(--c-separator-size, 100%);\n          }\n        "], ["\n          background-color: currentColor;\n\n          &[data-orientation='horizontal'] {\n            width: var(--c-separator-size, 100%);\n            height: var(--c-separator-weight, 1px);\n          }\n\n          &[data-orientation='vertical'] {\n            width: var(--c-separator-weight, 1px);\n            height: var(--c-separator-size, 100%);\n          }\n        "]))), size && (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            --c-separator-size: ", ";\n          "], ["\n            --c-separator-size: ", ";\n          "])), size), weight && (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            --c-separator-weight: ", ";\n          "], ["\n            --c-separator-weight: ", ";\n          "])), weight)],
    "data-orientation": orientation,
    ref: fwRef
  }, (0, components_utils_1.mergeProps)(separatorProps, (0, components_utils_1.styleProps)(props))), void 0);
}

exports.Separator = (0, react_2.forwardRef)(_Separator);
var templateObject_1, templateObject_2, templateObject_3;